import cls from 'classnames';
import styles from './index.module.scss';
import { useCallback, useState } from 'react';
import { Col, Row } from 'antd';
export default (props: Record<string, any>) => {
  const { data = [] } = props;
  const gotoDetail = useCallback(
    (item: any) => {
      window.open(item.redirectUrl);
    },
    [data]
  );
  return (
    <div className={styles['production-main']}>
      <Row className={cls('flex', 'v-center')}>
        <Col span={(data.goodsList?.length + 1) * 4} className={styles['title']}>
          {data.floorName}
        </Col>
      </Row>
      <Row className={cls(styles['production-content'], 'flex', 'v-center')}>
        <Col span={4} className={styles['left-icon']}>
          <img src={data.floorIcon} />
        </Col>
        {data.goodsList.map((item: any) => {
          return (
            <Col span={4} className={styles['inner-item']} key={item.id} onClick={() => gotoDetail(item)}>
              <img src={item.url} />
              {item.title}
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
